import PastLaunches from './PastLaunches';

export default PastLaunches;
